var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-app"},[_c('top-bar'),_vm._v(" "),_c('side-bar'),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }